import { reportingTodayInput } from '@/lib/report-timezone';

/** `<slug>_<location>[_<suffix>]_<today>.csv`, shared by every report's Export. */
export function reportFilename(slug: string, locationName: string | undefined, suffix?: string): string {
  const loc = (locationName && locationName.trim() ? locationName : 'all-locations')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  const today = reportingTodayInput();
  // Optional suffix lets a report drop the location name into the middle of the
  // file name, e.g. sales_summary_<location>_location_<date>.csv
  return `${slug}_${loc}${suffix ? `_${suffix}` : ''}_${today}.csv`;
}

/** Build a CSV from rows and hand it to the browser as a download. */
export function downloadCsv(filename: string, rows: (string | number)[][]) {
  const escape = (v: string | number) => {
    const s = String(v ?? '');
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = rows.map((r) => r.map(escape).join(',')).join('\n');
  // The BOM makes Excel open the file as UTF-8 rather than guessing.
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
